import { Injectable } from '@angular/core';

declare global {
  interface Window { gtag?: (...args: any[]) => void; }
}
@Injectable({
  providedIn: 'root'
})
export class AnalyticsService {

  pageView(url: string) {
    if (!window.gtag) return;
    window.gtag('event', 'page_view', {
      page_path: url,
    });
  }

  event(name: string, params: Record<string, any> = {}) {
    if (!window.gtag) return;
    window.gtag('event', name, params);
  }
}
